(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports["default"] = void 0;var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var _ShareTime = _interopRequireDefault(require("./ShareTime"));
// import Favorites from "./Favorites";
var
ButtonControl = /*#__PURE__*/function () {
  function ButtonControl(page) {(0, _classCallCheck2["default"])(this, ButtonControl);
    this.$page = page;
    this.$modeBox = $("#changeMode");
    this.$discoverMore = $("#discoverMore");
    this.videoBg = this.$page.find("#youtube");
    this.videoBtnControl = this.$page.find(".c-video-control-box");
    this.videoWrapper = this.$page.find(".video-wrapper");
    this.infoH = $(".c-video-info");
    this.theaterModeBtn = this.$page.find(".c-v-theater-mode");
    this.discoverMoreBtn = this.$page.find(".c-v-more");
    this.shareBtn = this.$page.find(".c-v-shares");
    this.videoId = window.YTPlayer.$youtube.data("videoId");
    this.active = "active";
    this.init();
  }(0, _createClass2["default"])(ButtonControl, [{ key: "init", value: function init()

    {var _this = this;
      //  剧场模式
      this._theaterMode();

      //  发现更多
      this._discoverMore();

      //  分享功能
      window.shareTime = new _ShareTime["default"](this.$page);

      this._hoverStyle();

      this._activeScoll();

      this.shareBtn.on("click", function (ev) {
        ev.stopPropagation();
        _this.shareBtn.addClass(_this.active);
        $(".js-discover-remove").click();
        $("#gospel-share-wrapper-pc").addClass("share_active");
      });

      $(".modal-dialog").on("click", function (ev) {
        ev.stopPropagation();
        $("#gospel-share-wrapper-pc").addClass("share_active");
      });
      $(document).on("click", function () {return _this.shareBtn.removeClass(_this.active);});
      $(".modal-content .close").on("click", function (ev) {
        ev.stopPropagation();
        _this.shareBtn.removeClass(_this.active);
        $("#gospel-share-wrapper-pc").removeClass("share_active");
      });
      $("#gospel-share-wrapper-pc").on("click", function () {return (
          $("#gospel-share-wrapper-pc").removeClass("share_active"));});

    } }, { key: "_hoverStyle", value: function _hoverStyle()

    {
      $(".c-video-info,.c-video-control-box.d-xl-flex").hover(
      function () {
        $(
        ".theater-mode .c-video-info,.theater-mode .c-video-control-box.d-xl-flex").
        css({
          opacity: 1,
          transition: "all ease .4s" });

      },
      function () {
        $(
        ".theater-mode .c-video-info,.theater-mode .c-video-control-box.d-xl-flex").
        css({
          opacity: 0.55,
          transition: "all ease .4s" });

      });

    }

    /***
       * 发现更多
       * @private
       */ }, { key: "_discoverMore", value: function _discoverMore()
    {var _this2 = this;
      // this.discoverMoreBtn.modal('toggle')
      this.discoverMoreBtn.on("click", function (ev) {
        var current = $(ev.currentTarget);
        if (!current.hasClass("c-v-btn-mb")) {
          window.innerWidth > 1200 && _this2.__discoverHeight();
          window.innerWidth < 1200 && _this2.__discoverHeightTab();
          _this2.discoverMoreBtn.toggleClass(_this2.active);
          _this2.$discoverMore.toggleClass("d-none");
        }
      });

      this.$discoverMore.append("<button class=\"js-discover-remove\"><i class=\"icon-close\"></i></button>");



      $(".js-discover-remove").on("click", function () {
        _this2.discoverMoreBtn.removeClass(_this2.active);
        _this2.$discoverMore.addClass("d-none");
      });
    }

    /***
       * 计算发现更多高度，准备好播放器后执行
       * @private
       */ }, { key: "__discoverHeight", value: function __discoverHeight()
    {
      var nao = this.videoBg.get(0).offsetHeight - 30;
      $("#Video_singe .v-v-info").css("height", nao);

      var vHeight = this.videoBg.get(0).offsetHeight + 65 + 90;
      this.$discoverMore.css("height", vHeight);
    }

    /***
       * 计算发现更多高度，准备好播放器后执行
       * @private
       */ }, { key: "__discoverHeightTab", value: function __discoverHeightTab()
    {
      var vHeight = this.videoBg.get(0).offsetHeight + 270;
      var infoH = this.infoH.get(0).offsetHeight;
      var H = Number(vHeight + infoH - 200);
      this.$discoverMore.css("height", H);
    }

    /***
       * 处理当前视频定位到顶部
       * @private
       */ }, { key: "_activeScoll", value: function _activeScoll()
    {
      var activeVideo = document.querySelector(".sigle-video-card.active");
      var VideoBox = document.querySelector(".continu-body>.nano-content");

      $(activeVideo).velocity("scroll", {
        container: $(VideoBox) });

    }

    /***
       * 剧场模式
       * @private
       */ }, { key: "_theaterMode", value: function _theaterMode()
    {var _this3 = this;
      var theaterList = $(".v-c-style .c-video-info");
      var isMode = false;

      this.theaterModeBtn.on("click", function () {
        $(".js-discover-remove").click();
        isMode = isMode === false ? true : false;
        _this3.theaterModeBtn.toggleClass(_this3.active);
        theaterList.toggleClass("d-none");
        if (isMode) {
          _this3.videoWrapper.addClass("col-lg-12").removeClass("col-lg-8");
          $("body").addClass("videopage");
        } else {
          _this3.videoWrapper.addClass("col-lg-8").removeClass("col-lg-12");
          $("body").removeClass("videopage");
        }

        _this3.__discoverHeight();
        //  发现更多背景高度重新计算
        var lTimer = setInterval(function () {
          _this3.__discoverHeight();
        }, 20);

        //  播放器窗口大小重新计算
        window.YTPlayer._setPlayerSize();

        _this3.__discoverHeight();

        setTimeout(function () {
          clearInterval(lTimer);
        }, 200);
      });
    } }]);return ButtonControl;}();var _default =


ButtonControl;exports["default"] = _default;

},{"./ShareTime":3,"@babel/runtime/helpers/classCallCheck":6,"@babel/runtime/helpers/createClass":7,"@babel/runtime/helpers/interopRequireDefault":8}],2:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports["default"] = void 0;var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var Likes = /*#__PURE__*/function () {
  function Likes() {(0, _classCallCheck2["default"])(this, Likes);
    this.init();
  }(0, _createClass2["default"])(Likes, [{ key: "init", value: function init()

    {
      var likeTitle = $(".c-v-likes");

      $(likeTitle).on("click", function (ev) {
        var cP = ev.currentTarget;
        if ($(cP).hasClass("active")) {
          return false;
        } else {
          $(cP).addClass("active");

          var num = $(cP).
          children("span").
          text();

          ++num;

          var ID = $(cP).data("post-id");

          ev.stopPropagation();

          $.ajax({
            type: "POST",
            url: ListAjax.ajaxurl,
            data: {
              action: "Like_ajax_callback",
              security: ListAjax.security,
              type: "click",
              pid: ID,
              num: num },

            success: function success(data) {
              $(cP).
              children("span").
              html(data);
            } });

          ev.stopPropagation();
        }
      });

      //  判断用户之前有没有点过赞
      // if (B.getStorage($('#youtubePlayer').data('videoId')) === 'true') {
      //   likeTitle.map((key,value) => {
      //     $(value).html(~~$(value).html() + 1)
      //   })
      //   $('.c-v-likes').addClass('active')
      //   // $('.c-v-likes i').attr('class','icon-thumb-up-alt')
      // }
    } }]);return Likes;}();var _default =


Likes;exports["default"] = _default;

},{"@babel/runtime/helpers/classCallCheck":6,"@babel/runtime/helpers/createClass":7,"@babel/runtime/helpers/interopRequireDefault":8}],3:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports["default"] = void 0;var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var ShareTime = /*#__PURE__*/function () {
  function ShareTime(page) {(0, _classCallCheck2["default"])(this, ShareTime);
    this.$page = page;
    this.$linkInput = $('.timeLink');
    this.$copyBtn = $('.copyLink');
    this.$timeInput = $('.setShareTime');
    this.$timeStart = $('#shareTime');
    this.$timeStartM = $('#shareTimeM');
    this.currentTime = 0;
    this.defaultLink = window.location.origin + window.location.pathname;
    this.isChangedTime = false;
    this.timeRegex = /^[0-9:]+$/;
    this.init();
  }(0, _createClass2["default"])(ShareTime, [{ key: "init", value: function init()

    {
      //  初始化内容（分享链接）
      this._initContent();

      //  复制分享链接
      this._copyLink();

      //  点击找到当前的视频时间
      this._clickGetTime();

      //  输入框发生改变
      this._inputChange();

      //  复制分享框
      this._copyShareBox();
    }

    /***
       * 输入框发生改变
       * @private
       */ }, { key: "_inputChange", value: function _inputChange()
    {var _this = this;
      this.$timeInput.on('change', function (ev) {
        //  判断是否已选勾选开始时间
        _this.isChangedTime = true;
        var value = ev.currentTarget.value;

        //  判断是否是时间码
        if (_this.timeRegex.test(value)) {
          var second = _this._unFormat(value);
          //  判断是否超过影片长
          window.YTPlayer.$player.getDuration().then(function (seconds) {

            if (!second || second > seconds) {
              return;
            } else {
              var format = _this._formatTime(second);
              var format2 = _this._formatTime2(second);
              _this.$timeInput.val(format2);
              _this.$linkInput.val(_this.defaultLink + '#t=' + format);
            }
          });
        }
        if (!_this.$timeStart.get(0).checked) {
          _this.$timeStart.get(0).checked = true;
          // this.$timeStartM.get(0).checked = true
        }

      });

    }

    /***
       * 获取视频当前时间赋值到分享input
       * @private
       */ }, { key: "_clickGetTime", value: function _clickGetTime()
    {var _this2 = this;
      this.$page.find('.c-v-shares').on('click', function (ev) {
        _this2._getCurrentTime(window, true);
      });
      // $('#gospel-share-wrapper-pc').on('show.bs.modal', () => {
      //   console.log(78888)
      //   this._getCurrentTime(window, true)
      // })

      // $('.gospel-share-triggers').on('el-share-open', () => {
      //   this._getCurrentTime(window, true)
      // })

      this.$timeStart.on('click', function () {
        _this2._getCurrentTime(window, false);
      });

      this.$timeStartM.on('click', function () {return _this2.$timeStart.click();});
    }

    /***
       * 复制分享链接
       * @private
       */ }, { key: "_copyLink", value: function _copyLink()
    {var _this3 = this;
      this.$copyBtn.on('click', function () {
        _this3.$linkInput.select();
        document.execCommand('copy');
        $('#gospel-share-wrapper-mobile').sideNav('hide');
        $.toast({
          html: window._player_msg.copied });

      });
    }

    /***
       * 复制分享框
       * @private
       */ }, { key: "_copyShareBox", value: function _copyShareBox()
    {
      var iShareHtml = $('#gospel-share-wrapper-pc').find('.a2a_kit.a2a_kit_size_40.addtoany_list').clone();
      // $('#gospel-share-wrapper-mobile .addtoany_list').remove()
      // let iBefore = $('#gospel-share-wrapper-mobile .share-icon-box').html()
      // console.log(iBefore)
      // $('#gospel-share-wrapper-mobile .share-icon-box').prepend(iShareHtml)
    }
    /***
       *  获取视频当前播放时间赋值
       * 在YTPlayer准备好后调用
       * @param window
       * @param isChange  true 更新时间  false 不更新时间
       * @private
       */ }, { key: "_getCurrentTime", value: function _getCurrentTime(
    w, isChange) {var _this4 = this;
      w.YTPlayer && w.YTPlayer.$player.getCurrentPosition().then(function (seconds) {
        //  获取当前视频播放时间
        if (isChange) {
          _this4.currentTime = seconds;
        }
        //  时间框没有focus时执行
        !_this4.$timeInput.is(':focus') && _this4.$timeInput.val(_this4._formatTime2(_this4.currentTime));
        //  判断是否勾选开始时间
        //  点击赋值到分享链接

        _this4.$timeStartM.get(0).checked = _this4.$timeStart.get(0).checked ? true : false;
        _this4.$timeStart.prop('checked') && _this4.$linkInput.val("".concat(_this4.defaultLink, "#t=").concat(_this4._formatTime(_this4.currentTime)));
        //  否则赋值为默认链接
        !_this4.$timeStart.prop('checked') && _this4._initContent();
      });
    }

    /***
       * 获取分享链接赋值
       * @param window
       * @private
       */ }, { key: "_initContent", value: function _initContent()
    {
      this.$linkInput.val(this.defaultLink);
    }

    /**
       * 获取定位时间 也就是hash值
       */ }, { key: "_getLocationTime", value: function _getLocationTime()
    {
      if (location.hash.slice(0, 3) === '#t=') {
        //  检查是否是正常的时间码
        if (!this._checkTime()) {
          return false;
        }

        //  0h0m0s
        var a = location.hash.slice(3).split('');
        var amount = 0;
        if (~a.indexOf('h')) {
          amount += parseInt(a.splice(0, a.indexOf('h') + 1).join('')) * 3600;
        }

        if (~a.indexOf('m')) {
          amount += parseInt(a.splice(0, a.indexOf('m') + 1).join('')) * 60;
        }

        if (~a.indexOf('s')) {
          amount += parseInt(a.splice(0, a.indexOf('s') + 1).join(''));
        }

        return amount;
      }
      return false;
    } }, { key: "_checkTime", value: function _checkTime()

    {
      var a = location.hash.slice(3);

      if (!/^[0-9hms]{2,9}$/.test(a)) {
        return false;
      }

      var s = a.replace('h', ':').replace('m', ':').replace('s', ':');

      var newA = s.split(':');
      //  过滤 24hh24ss232mm
      if (newA.length > 4) {
        return false;
      }

      //  过滤 008:6554:02
      var isFalse = true;
      newA.map(function (value) {
        if (value.length > 2) {
          isFalse = false;
        }
        if (parseInt(value) > 59) {
          isFalse = false;
        }
      });
      if (!isFalse) {
        return false;
      }

      return true;
    }

    /**
       * 将 00:00:00 转换为 second
       */ }, { key: "_unFormat", value: function _unFormat(
    time) {
      var arr = time.split(':');
      //  过滤 00:00:00:
      if (arr.length > 4) {
        return false;
      }

      //  过滤 008:6554:02
      var isFalse = true;
      arr.map(function (value) {
        if (value.length > 2) {
          isFalse = false;
        }
        //  过滤 58:96:75
        if (parseInt(value) > 59) {
          isFalse = false;
        }
      });
      if (!isFalse) {
        return false;
      }


      arr.reverse();
      var s = parseInt(arr[0]);
      var m = arr[1] ? parseInt(arr[1]) * 60 : 0;
      var h = arr[2] ? parseInt(arr[2]) * 3600 : 0;

      return h + m + s;
    }

    /***
       * 格式化时间
       * @param second
       * @returns {string}
       * @private
       */ }, { key: "_formatTime", value: function _formatTime(
    second) {
      var h = String('00' + Math.floor(second / 3600)).slice(-2) + 'h';
      var m = String('00' + Math.floor(second % 3600 / 60)).slice(-2) + 'm';
      var s = String('00' + Math.floor(second % 3600 % 60)).slice(-2) + 's';

      //  过滤空时间
      h = h.slice(0, 2) == '00' ? '' : h;
      m = m.slice(0, 2) == '00' ? '' : m;

      // 过滤单数时间
      h = h.slice(0, 1) == '0' ? h.slice(1) : h;
      m = m.slice(0, 1) == '0' ? m.slice(1) : m;
      s = s.slice(0, 1) == '0' ? s.slice(1) : s;

      return h + m + s;
    }

    /***
       * 格式化时间
       * @param second
       * @returns {string}
       * @private
       */ }, { key: "_formatTime2", value: function _formatTime2(
    second) {
      var h = String('00' + Math.floor(second / 3600)).slice(-2) + ':';
      var m = String('00' + Math.floor(second % 3600 / 60)).slice(-2) + ':';
      var s = String('00' + Math.floor(second % 3600 % 60)).slice(-2);

      //  过滤空时间
      h = h.slice(0, 2) == '00' ? '' : h;

      return h + m + s;
    } }]);return ShareTime;}();var _default =


ShareTime;exports["default"] = _default;

},{"@babel/runtime/helpers/classCallCheck":6,"@babel/runtime/helpers/createClass":7,"@babel/runtime/helpers/interopRequireDefault":8}],4:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports["default"] = void 0;var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var video_singe = /*#__PURE__*/function () {
  function video_singe() {(0, _classCallCheck2["default"])(this, video_singe);
    this.$page = $("#Video_singe");
    this.$youtube = $("#youtube");
    this.$videoWrapper = this.$page.find(".video-wrapper");
    this.posters_box = $(".video_list_box");
    this.$player;
    this.init();
  }(0, _createClass2["default"])(video_singe, [{ key: "init", value: function init()
    {
      this.resizeWindow(window);
      this.initPlayer();
      this.layout();
      this._viewMore();
      this._fb_comment();
    } }, { key: "resizeWindow", value: function resizeWindow(

    w) {var _this = this;
      // resize window deal with video width and height
      w.addEventListener("resize", function () {
        _this._setPlayerSize();
      });
    } }, { key: "initPlayer", value: function initPlayer()

    {var _this2 = this;
      window.isRepeat = true;
      var oVideoBox = $("#youtube");

      //  calculate video width and height
      var iWidth = 0;
      if (window.innerWidth < 1200) {
        iWidth = window.innerWidth;
        var fixMargin =
        ($(window).width() - $("#changeMode > .container").width()) / 2;
        $("#youtube").css({
          "margin-left": -fixMargin });

      } else {
        iWidth = this.$youtube.width();
        $("#youtube").css("margin-left", 0);
      }
      var iHeight = iWidth * 0.5625;

      this.$player = oVideoBox.G2embedded(
      {
        videoId: this.$youtube.get(0).dataset.videoId,
        height: iHeight,
        width: iWidth },

      "YouTube");

      oVideoBox.on("playerReady", function () {
        var second = window.shareTime._getLocationTime();
        //  计算下发现更多的高度
        window.Control.__discoverHeight();
        //  处理自动定位
        second &&
        _this2.$player.
        getCurrentPosition().
        then(function (seconds) {return second > seconds && _this2.$player.seek(second);});
      });

      oVideoBox.on("ended", function () {
        // if (window.isRepeat) {
        //   this.$player.seek(0)
        //   this.$player.play()
        // } else {
        _this2._videoEnd();
        // }
      });

      var currentId = this.$youtube.get(0).dataset.videoId;
      var listCurrent = this.$page.find(".continu-body .sigle-video-card[data-video-id=\"".concat(
      currentId, "\"]"));

      listCurrent.addClass("active");
    } }, { key: "_videoEnd", value: function _videoEnd()

    {
      var current = $(".continu-body .sigle-video-card.active");
      if (current.next().length !== 0) {
        window.location.href = current.
        next().
        children(".video-img").
        attr("href");
      } else {
        window.location.href = $(".continu-body .sigle-video-card").
        eq(0).
        children(".video-img").
        attr("href");
      }
    } }, { key: "_setPlayerSize", value: function _setPlayerSize()

    {
      var iWidth = 0;
      if ($(window).width() < 1200) {
        iWidth = $(window).width();
        var fixMargin =
        ($(window).width() - $("#changeMode > .container").width()) / 2;
        $("#youtube").css("margin-left", -fixMargin);
      } else {
        iWidth = this.$videoWrapper.width();
        $("#youtube").css("margin-left", 0);
      }
      var iHeight = iWidth * 0.5625;
      this.$player && this.$player.setSize(iWidth, iHeight);
    }

    /***
       * 处理移动端布局
       * @private
       */ }, { key: "layout", value: function layout()
    {
      $(".section-clone").each(function () {
        var cloneTo = $(this).data("clone-to");
        $("#".concat(cloneTo)).html($(this).html());
      });

      if ($(window).width() < 1200) {
        $.map($("#continue-list-mb img"), function (v, k) {
          $(v).attr("src", $(v).data("src"));
        });
      }
    } }, { key: "_viewMore", value: function _viewMore()

    {
      if (window.innerWidth > 1200) {
        viewMore(
        "[data-clone-to=video-assist-mb] #viewMore",
        "[data-clone-to=video-assist-mb] .video-upTime-views");

      } else {
        viewMore(
        "#video-assist-mb #viewMore",
        "#video-assist-mb .video-upTime-views");

      }

      function viewMore(btn, content) {
        $(btn).on("click", function (ev) {
          var btnMore = ev.currentTarget;
          $(btnMore).toggleClass("open");
          $(content).toggleClass("open");
          if ($(btnMore).hasClass("open")) {
            $(btnMore).
            find("span").
            html("收起");
          } else {
            $(btnMore).
            find("span").
            html("顯示完整資訊");
          }
        });
      }
    } }, { key: "_fb_comment", value: function _fb_comment()

    {
      $(".v-facebook-text a").on("click", function () {
        var ch = $("#facebook_comment").offset().top;
        $("html,body").
        stop().
        animate(
        {
          scrollTop: ch },

        500);

        // console.log(ch);
      });
    } }]);return video_singe;}();var _default =


video_singe;exports["default"] = _default;

},{"@babel/runtime/helpers/classCallCheck":6,"@babel/runtime/helpers/createClass":7,"@babel/runtime/helpers/interopRequireDefault":8}],5:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var _video_singe = _interopRequireDefault(require("./Modules/video-post/video_singe"));
var _ButtonControl = _interopRequireDefault(require("./Modules/video-post/ButtonControl"));
var _Likes = _interopRequireDefault(require("./Modules/video-post/Likes"));var

VideoPlayer = /*#__PURE__*/function () {
  function VideoPlayer() {(0, _classCallCheck2["default"])(this, VideoPlayer);
    this.$page = $('#Video_singe');
    this.$nano = $('.v-c-style .nano');
    this.init();
  }(0, _createClass2["default"])(VideoPlayer, [{ key: "init", value: function init()

    {
      //  初始化youtube播放器
      window.YTPlayer = new _video_singe["default"](this.$page);

      //  功能按钮处理
      window.Control = new _ButtonControl["default"](this.$page);

      window.videoLike = new _Likes["default"]();
      //  处理影片信息
      this._videoDes();

      this._other();

      this._plugin();

      this._moreInfo();

      this._content();
    } }, { key: "_plugin", value: function _plugin()

    {
      $('.velocity-animate').velocity('transition.slideUpIn', {
        stagger: 20 });


    } }, { key: "_content", value: function _content()

    {var _this = this;
      window.setTimeout(function () {return _this.$nano.nanoScroller({
          alwaysVisible: true });},
      300);
    } }, { key: "_other", value: function _other()
    {
      this.$page.find('.video-list-favorite .img-card').parent().css('position', 'relative');
    } }, { key: "_videoDes", value: function _videoDes()

    {
      var descBox = $('#desc');
      var descBtn = this.$page.find('.show-more-btn');

      descBtn.on('click', function (ev) {
        $(ev.currentTarget).toggleClass('active');
        descBox.toggleClass('active');
      });

    }
    //展开更多
  }, { key: "_moreInfo", value: function _moreInfo() {
      if ($('#changeMode .video-upTime-views .dce').height() > '120') {
        $('#changeMode .video-upTime-views .dce').addClass('dec_active');
      } else {
        $('#changeMode .video-upTime-views .arrow_box').css('display', 'none');
      }
      $('.arrow_box .more').on('click', function (e) {
        $('#changeMode .video-upTime-views .dce').removeClass('dec_active');
        $('.video-upTime-views').addClass('video_box_active');
      });
    } }]);return VideoPlayer;}();


new VideoPlayer();

},{"./Modules/video-post/ButtonControl":1,"./Modules/video-post/Likes":2,"./Modules/video-post/video_singe":4,"@babel/runtime/helpers/classCallCheck":6,"@babel/runtime/helpers/createClass":7,"@babel/runtime/helpers/interopRequireDefault":8}],6:[function(require,module,exports){
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
},{}],7:[function(require,module,exports){
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
},{}],8:[function(require,module,exports){
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
},{}]},{},[5])

//# sourceMappingURL=post-video.js.map
